export default __webpack_public_path__ + "static/media/email-svg-ic.a1ae1b43.svg";